import { siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">
              <a href="/" className="hover:text-primary-400 transition-colors">
                {siteInfo.name}
              </a>
            </h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              {siteInfo.description.slice(0, 60)}...
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a></li>
              <li><a href="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">漫画分类</a></li>
              <li><a href="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">热门漫画</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">终末的女武神</a></li>
              <li><a href="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">咒术回战</a></li>
              <li><a href="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">海贼王</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                <span>{siteInfo.phone}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {siteInfo.year} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="/about" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="/about" className="hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
            <a href="/about" className="hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}